import { isIgnored } from './is-ignored';
export var isValidTargetNode = function isValidTargetNode(node) {
  return !!node && !isIgnored(node);
};